<template>
    <div class="Product">
        <img v-if="bannerPath"
             :src="bannerPath"
             @click="jump()" />
        <router-view></router-view>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { queryproductbanner } from "@/api/productInfo";
export default {
    data() {
        return {
            bannerHeight: "400",
            imaUrl: "@/assets/images/banner1.png"
        };
    },
    computed: {
        ...mapGetters(["activeIndex", "bannerPath"])
    },
    mounted() {
        // if (this.$route.query.id) {
        //     this.$store.dispatch("BannerPath", this.$route.query.id);
        // }
    },
    methods: {
        jump() {
            queryproductbanner(this.activeIndex).then(res => {
                if (res.status === 2000) {
                    if (res.data.demoFlag) {
                        this.$store.dispatch("UpdateActive", res.data);
                    }
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.Product {
    img {
        width: 100%;
        max-height: 400px;
    }
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #f5f6f7;
        .el-breadcrumb {
            line-height: 50px;
        }
    }
}
</style>
